import React from 'react';
import FlujoFondos from './FlujoFondos';

export default function FlujoFondosBancosPage() {
  return <FlujoFondos initialSection="bancos" />;
}
